import gql from 'graphql-tag';

const resetFlatRateOfferBatchMutation = gql`
  mutation resetFlatRateOfferBatch($input: ResetFlatRateOfferBatchInput!) {
    resetFlatRateOfferBatch(input: $input) {
      success
      errors
    }
  }
`;

export default resetFlatRateOfferBatchMutation;
